import { render } from "./index-three.vue?vue&type=template&id=632e17e0"
import script from "./index-three.vue?vue&type=script&lang=js"
export * from "./index-three.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__